module.exports = __webpack_public_path__ + "img/anchor.9135d849.svg";